import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_as93nxevgz: FaireBrandEntity = {
  token: "b_as93nxevgz",
  type: "brand",
  name: "Rachel Brooks Design, LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/78917428c86008a176230bdb32f0847b9d1d82b64e53aa1ee652ba002f1c8605.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ae6dc2756b308a984c8af541530e5c74a734269e3b7fb6766c3a9bd473e4543c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/78917428c86008a176230bdb32f0847b9d1d82b64e53aa1ee652ba002f1c8605.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ae6dc2756b308a984c8af541530e5c74a734269e3b7fb6766c3a9bd473e4543c.jpeg",
  location: "Tupelo, MS, USA",
  minimumOrderDollars: 1500,
  rating: 5,
  reviewCount: 24,
  isInsider: true,
  description:
    "Rachel Brooks Design was born out of a desire to commit my work to the Kingdom of God. For two years I prayed about how my artwork and day to day life could make a difference - and one day, the Lord showed me that it was in who I could hire that would make a difference. By ordering with Rachel Brooks Design, you are helping to \nprovide a job opportunity for women in recovery from addiction, sex trafficking, and many other broken situations. We only hire women who need us. We want to provide as many women as we can with a healthy, uplifting, and loving work environment. along with mentor-ship program, resources that can help them get back on their feet, job skills and life skills that they can take with them wherever they go. All of the products you see in our shop are designed by me, Rachel, then they are printed, produced, sewn, and created right here in our building\nby these amazing women! Thank you for supporting what the Lord is doing in our community through ordering with our company.\n\nThank you so much for shopping with us.\nYour support means more than \nyou could ever imagine!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:03.022Z",
    importedBy: "entity-db-cli",
  },
};
